import type { ReactNode } from 'react';
import { Marca, Wordmark } from '@/components/Logo';

/**
 * Moldura das telas de autenticação.
 *
 * O wordmark usa o papel "display" (manual §2): Space Grotesk 700, `clamp()` para
 * responsividade, tracking negativo. É uma das duas telas onde o display aparece.
 */
export function AuthLayout({ subtitulo, children }: { subtitulo: string; children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-6">
      <div className="w-full max-w-md">
        <div className="mb-3 flex items-center justify-center gap-4">
          <Marca tamanho={64} />
          <Wordmark className="tipo-display" />
        </div>
        <p className="mb-8 text-center text-[13px] leading-[1.5] text-text-secondary">
          {subtitulo}
        </p>
        {children}
      </div>
    </div>
  );
}
